import styled from "styled-components"
import ratesbanner from "../../img/background.jpg"

export const WrapBanner = styled.div`
    height: 70vh;

    .parallax {
        background-image: url(${ratesbanner});
        min-height: 70vh; 
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .innertxt{
        width: 100%;
        height: 70vh;
        position: relative;
        top: -70vh;
        padding: 80px 0;
        text-align: center;
        background: rgba(0, 0, 0, .6);

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        
        color: #fff;

        h1{
            width: 80%;
            font-size: clamp(1.2rem, 2.5vw, 3rem);
            margin: 20px 0; 
        }

        .p-style{
            width: 70%;   
            margin-top: 20px;
            margin-bottom: 30px;

            @media (min-width: 950px){
                width: 30%;
            }
        }

        p{
            width: 80%;
            font-size: clamp(1rem, 2.5vw, 1.6rem);
        }

        button{
            width: 200px;
            padding: 10px 10px; 
            border-radius: 30px;
            border: none;
            background: #26a6d1;
            color: #fff;
            margin-top: 20px;

            &:hover{
                background: #0a556e;
            }
        }

    }
`